const PageNotFound = () => {
    return (
        <h1>Sorry but this page not found!</h1>
    )
}

export default PageNotFound;